import { z } from "zod";
export const CONTACT_LIST_SORTS = [
    "FIRST_NAME_ASC",
    "FIRST_NAME_DESC",
    "LAST_NAME_ASC",
    "LAST_NAME_DESC",
    "CREATED_AT_DESC",
    "CREATED_AT_ASC",
    "EMAIL_ASC",
    "EMAIL_DESC",
    "PHONE_ASC",
    "PHONE_DESC",
];
export const DEFAULT_CONTACT_LIST_SORT = "FIRST_NAME_ASC";
export const CONTACT_LIST_PAGE_SIZES = [25, 50, 100];
export const DEFAULT_CONTACT_LIST_PAGE_SIZE = 25;
export const contactListHasEmailFilterSchema = z.enum(["ANY", "HAS", "MISSING"]);
export const contactListHasPhoneFilterSchema = z.enum(["ANY", "HAS", "MISSING"]);
export const contactListPlatformFilterSchema = z.enum([
    "ANY",
    "WHATSAPP",
    "FACEBOOK",
    "INSTAGRAM",
    "LINKED",
    "UNLINKED",
]);
export const contactListQuerySchema = z.object({
    page: z.coerce.number().int().positive().optional(),
    pageSize: z.coerce
        .number()
        .int()
        .refine((n) => CONTACT_LIST_PAGE_SIZES.includes(n), {
        message: "Invalid page size",
    })
        .optional(),
    search: z
        .string()
        .transform((s) => {
        const t = s.trim();
        return t.length > 0 ? t : undefined;
    })
        .optional(),
    groupId: z.coerce.number().int().positive().optional(),
    hasEmail: contactListHasEmailFilterSchema.optional(),
    hasPhone: contactListHasPhoneFilterSchema.optional(),
    platform: contactListPlatformFilterSchema.optional(),
    createdFrom: z.string().datetime({ offset: true }).optional(),
    createdTo: z.string().datetime({ offset: true }).optional(),
    sort: z.enum(CONTACT_LIST_SORTS).optional(),
    includeDeleted: z.coerce.boolean().optional(),
    /** ISO country for interpreting national phone digits in search. */
    phoneCountryIso: z.string().trim().length(2).optional(),
});
/** Matching bulk selection uses list filters only — never page, pageSize, or sort. */
export const contactBulkMatchingQuerySchema = contactListQuerySchema.omit({
    page: true,
    pageSize: true,
    sort: true,
    includeDeleted: true,
});
export function toContactBulkMatchingQuery(query) {
    return contactBulkMatchingQuerySchema.parse({
        search: query.search,
        groupId: query.groupId,
        hasEmail: query.hasEmail,
        hasPhone: query.hasPhone,
        platform: query.platform,
        createdFrom: query.createdFrom,
        createdTo: query.createdTo,
        phoneCountryIso: query.phoneCountryIso,
    });
}
//# sourceMappingURL=contact-list-query.js.map